import FamilySubscriptionPopup from "../../Family/Babillard/Popups/FamilySubscriptionPopup";
import "../../../resources/less/Family/FamilyOnboarding/popups/FamilySubRequiredPopup.less";
import { IPaywallPopup } from "./IPaywallPopup";
import TroubadourPaywallPopup from "./TroubadourPaywallPopup";

export default class PaywallPopupFactory {
  public Create(): IPaywallPopup {
    if ($("#family-sub-required-popup").length > 0) {
      return new FamilySubscriptionPopup();
    }

    return new TroubadourPaywallPopup();
  }
}
